<template>
<div class="first_step">
    <ul class="content_ul" v-if="showFirstContent">
        <li class="content_li" v-for="(item,index) in branchList" :key="index" @click="toNext(item)">
            <div class="img_area">
                <div class="img_wrap img_wrap_1" v-if="item.coverMaterialUrl">
                    <div class="mask"></div>
                    <img :src="item.coverMaterialUrl | addHost" alt="hi">
                </div>
                <div class="img_wrap img_wrap_2" v-if="!item.coverMaterialUrl">
                    <div class="mask"></div>
                    <img src="../../assets/images/parent-course/block.png" alt="hi">
                </div>
                <p class="desc">{{item.name}}</p>
            </div>
        </li>
    </ul>
</div>
</template>

<script>
import { getRequest } from '../../assets/js/api'
export default {
  name: 'first-step',
  components: {},
  props: {
    showFirstContent: {
        type: Boolean,
        default:true
    },
    branchList: {
        type: Array,
        default:() => []
    }
  },
  data() {
    return {
        flagExit: false,//标识是否有文章或者视频
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 一级维度下，点击跳转到二级维度
    async toNext(item) {
        // 当点击一级栏目下面的内容的时候，有两种情况，一种情况是有视频或者文章。另没有视频文章但是有栏目层级
        this.existContents(item.id,item)
         // 保存当前栏目的id，nextVideo中需要使用栏目id入参
        localStorage.setItem('columnId',JSON.stringify(item.id))
    },

    // 判断当前栏目下的内容种类，是有文章/视频或者层级关系
    existContents(columnId,item) {
        try {
            getRequest('/api-content/column/exist/contents?columnId='  + columnId).then((res) => {
                let {code, data, message} = res
                if(res && code === 200) {
                    // 如果data为true，有视频或者文章，fasle就没有视频或者文章
                    // 有视频文章，就显示tab，并且可以进行切换
                    if(data) {
                        // data为true，有文章视频，直接进入到路由thirdPlate
                        this.flagExit = true
                        this.$storage.setStore('firstOtherPlateInfo',item)
                        this.$router.push('/thirdPlate')
                    } else {
                        // 没有视频文章，去走层级
                        this.flagExit = false
                        this.$storage.setStore('firstPlateInfo',item)
                        this.$router.push('/secondPlate')
                    }
                } else {
                    Toast(message)
                }
            })
        } catch (error) {
    
        }
    },
  },
  filters: {
      addHost: function(val) {
        let host = location.host
        // return 'http://' + host + '/' + val
        //  return 'http://172.16.12.104:8999/' + val
        return val
      }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
.first_step {
    .content_ul {
        .content_li {
            width: 345px;
            min-height: 210px;
            margin-bottom: 20px;
            background-color: #fff;
            border-radius: 16px;
            box-shadow: 0px 2px 5px 1px rgba(217, 217, 217,.2);
            &:first-child {
                margin-top: 20px;
            }
            .img_area {
                position: relative;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .img_wrap {
                    // border: 1px solid red;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 15px;       
                    width: 315px;
                    height: 180px;
                    border-radius: 8px;
                    background-color: #f8f7fa;
                    position: relative;
                    .mask {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background-color: rgba(0,0,0,.1);
                        border-radius: 8px;
                    }
                    // border: 1px solid red;
                    &.img_wrap_1 {
                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 8px;
                        }
                    }
                    &.img_wrap_2 {
                        img {
                            width: 44px;
                            height: 44px;
                        }
                    }
                    // img {
                    //     width: 44px;
                    //     height: 44px;
                    // }
                }
                .desc {
                    position: absolute;
                    bottom: 16px;
                    left: 32px;
                    height: 22px;
                    font-size: 16px;
                    color: #fff !important;
                    line-height: 22px;
                    z-index: 999999;
                }
            }
        }
    }
}
</style>
